import React from 'react';
import { Quote, Star } from 'lucide-react';

const ClientTestimonials = () => {
  const testimonials = [
    "My week finally feels controlled again.",
    "We stopped dropping balls across projects.",
    "I gained hours back without losing momentum."
  ];

  return (
    <section id="client-testimonials" className="section-padding bg-white">
      <div className="container-center">
        {/* Section Header */}
        <div className="text-center space-y-6 mb-16 animate-slide-up">
          <div className="inline-flex items-center space-x-2 bg-burnt-orange/10 px-4 py-2 rounded-full">
            <Quote className="h-4 w-4 text-burnt-orange" />
            <span className="text-sm font-semibold text-burnt-orange">Client Feedback</span>
          </div>
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-olive-brown">
            Quick proof from our clients:
          </h2>
        </div>

        {/* Testimonials Grid */}
        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            {testimonials.map((testimonial, index) => (
              <div 
                key={index}
                className="bg-gray-50 rounded-3xl p-8 text-center card-shadow hover:shadow-xl transition-all duration-500 animate-slide-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="space-y-6">
                  {/* Quote Icon */}
                  <div className="w-16 h-16 bg-burnt-orange/20 rounded-full flex items-center justify-center mx-auto">
                    <Quote className="h-8 w-8 text-burnt-orange" />
                  </div>

                  {/* Testimonial */}
                  <blockquote className="text-xl font-medium text-olive-brown leading-relaxed">
                    "{testimonial}"
                  </blockquote>

                  {/* Rating Stars */}
                  <div className="flex justify-center space-x-1">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        className="h-4 w-4 text-burnt-orange fill-current"
                        aria-hidden="true"
                      />
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Disclaimer */}
          <div className="text-center bg-gray-50 rounded-xl p-6">
            <p className="text-olive-brown/70 italic leading-relaxed">
              Results vary by role, workload, and scope. We'll confirm what's realistic during onboarding.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientTestimonials;